/**
 * Adapter so shared @way/website-themes components receive the same env shape
 * as car-wash-website-builder-app (apiUrl, baseUrl, websitePlatformHost).
 */
import { environment as appEnvironment } from '../../environments/environment';

function siteOrigin(baseUrl: string): string {
  const normalized = baseUrl.replace(/\/api\/?$/, '').replace(/\/$/, '');
  if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
    return normalized;
  }
  return `https://${normalized}`;
}

const baseUrl = siteOrigin(appEnvironment.baseUrl);

export const environment = {
  production: appEnvironment.production,
  apiUrl: `${appEnvironment.baseUrl.replace(/\/$/, '')}/${appEnvironment.apiVersion}`,
  baseUrl,
  websitePlatformHost: new URL(baseUrl).host,
};
